export const POSITION_FIELD_NAME = 'objectPosition';
export const OBJECT_FIELD_NAME = 'objectName';
